export default "__VITE_ASSET__BKyecx5Y__"